<template>
  <div class="innerBox">

    <div class="row">
        <div class="col-md-4 mt-3">
            <h2>Welcome, {{$store.state.userData.userData.name.toUpperCase()}}</h2>
        </div>

        <!-- <i class="fa fa-cog fa-4x"></i> -->
        <!-- Filter Start -->
        <div class="col-md-8">
            <div class="row">
                <div class="col-md-3 homeFilter mt-2 p-10">
                    <span style="color:white">Test</span>
                    <button
                        type="button"
                        class="btn w-100 mt-1"
                        style="height:40px"
                        :class="selected.time == 0 ? 'buttonFilterSelected' : 'buttonFilter'"
                        @click="selected.time = 0"
                        >Bulan Ini <i class="fas fa-stopwatch"></i></button>
                </div>
                <div class="col-md-9 border border-info shadow rounded p-10 mt-2">
                    <span>Filter Waktu</span>
                    <div class="row">
                        <div class="col-md homeFilter mt-1" v-for="(time, index) in options.time">
                            <button
                                type="button"
                                class="btn w-100 h-100"
                                :class="selected.time == index + 1 ? 'buttonFilterSelected' : 'buttonFilter'"
                                @click="selected.time = index + 1"
                            >{{ time }} <i class="fas fa-stopwatch"></i></button>
                        </div>
                        <div class="col-md homeFilter mt-1">
                            <MultiSelect
                                :options="options.year"
                                :allow-empty="false"
                                v-model="selected.year"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Filter End -->
    </div>

    <!-- Content Start -->
    <div class="row mt-4" v-if="
        highlightData.work_order &&
        highlightData.estimations &&
        highlightData.spareparts &&
        highlightData.finance
    ">
        <!-- Work Order Start -->
        <div class="col-md-4 outerBox">
            <work-order-section
                v-if="highlightData.work_order"
                :data="highlightData.work_order"
            ></work-order-section>
        </div>
        <!-- Work Order End -->

        <!-- Estimation & Sparepart Start -->
        <div class="col-md-4 outerBox">
            <!-- Estimation Start -->
            <estimation-section
                v-if="highlightData.estimations"
                :data="highlightData.estimations"
            ></estimation-section>
            <!-- Estimation End -->

            <!-- Sparepart Start -->
            <sparepart-section
                v-if="highlightData.spareparts"
                :data="highlightData.spareparts"
            ></sparepart-section>
            <!-- Sparepart End -->
        </div>
        <!-- Estimation & Sparepart End -->

        <!-- Finance Start -->
        <div class="col-md-4 outerBox">
            <finance-section
                v-if="highlightData.finance"
                :data="highlightData.finance"
            ></finance-section>
        </div>
        <!-- Finance End -->
    </div>
    <!-- Content End -->

    <div v-else>
        <div class="row">
            <div class="col pt-5 pb-5">
                <h1 class="mt-5 mb-5 text-center">Loading...</h1>
            </div>
        </div>
    </div>

</div>
</template>

<script>
    // import comparisonRevenue from './children/comparisonRevenueChart'

    import moment from 'moment'

    import workOrderSection from './sections/workOrderSection'
    import estimationSection from './sections/estimationSection'
    import sparepartSection from './sections/sparepartSection'
    import financeSection from './sections/financeSection'
    
    export default {
        data() {
            return {
                options: {
                    time: ['Semester 1', 'Semester 2'],
                    year: [],
                },
                selected: {
                    time: 0,

                    year: new moment().year()
                },
                filter: {
                    start: new moment().startOf('month').format('Y-MM-DD'),
                    end: new moment().format("Y-MM-DD")
                },
                woOngoing: [],
                highlightData: {
                    work_order : null,
                    estimations : null,
                    spareparts : null,
                    finance : null
                },
                ready: {
                    finance: {
                        api1: false,
                        api2: false
                    },
                },
            }
        },
        watch: {
            selected: {
                deep: true,
                handler: function() {
                    if (this.selected.time > 0) {
                        this.filter.start = new moment(new Date(this.selected.year, this.selected.time == 1 ? 0 : 6, 1)).format("Y-MM-DD")
                        this.filter.end = new moment(new Date(this.selected.year, this.selected.time == 1 ? 6 : 12, 0)).format("Y-MM-DD")
                    } else {
                        this.filter.start = new moment().startOf('month').format('Y-MM-DD'),
                            this.filter.end = new moment().format("Y-MM-DD")
                    }

                    this.loadData()

                }
            }
        },
        components: {
            // comparisonRevenue,
            workOrderSection,
            estimationSection,
            sparepartSection,
            financeSection,
        },
        mounted() {
            this.generateYearOptions();
            // this.generateDummy();
            this.loadData();
        },
        computed: {
            financeReady() {
                return this.ready.finance.api1 && this.ready.finance.api2
            },
            averageStatistics() {
                if (this.highlightData) {
                    return {
                        revenuePerWO: this.estimationRevenue != 'Loading ...' ? this.highlightData.finance.wo_count == 0 ? 0 : this.numberWithCommas(parseInt(this.estimationRevenue) / parseInt(this.highlightData.finance.wo_count)) : 'Loading...'
                    }
                } else {
                    return 'Loading ...'
                }
            },
        },
        methods: {
            async fetchFinanceData(filterTime) {
                this.ready.finance.api1 = false;
                this.ready.finance.api2 = false;
                let finance = {}

                await this.$http.get(`/api/v1/homepage/price-detail${filterTime}`)
                    .then((resp) => {
                        for (var i in resp.data.data) {
                            finance[i] = resp.data.data[i] ? resp.data.data[i] : 0
                        }
                    })
                    .then(() => {
                        this.ready.finance.api1 = true;
                    })
                    .catch((err) => {
                        console.log(err)
                    })

                await this.$http.get(`/api/v1/insurance/report/summary${filterTime}`)
                    .then((resp) => {
                        for (var i in resp.data.data) {
                            finance[i] = resp.data.data[i] ? resp.data.data[i] : 0
                        }
                    })
                    .then(() => {
                        this.ready.finance.api2 = true;
                    })
                    .catch((err) => {
                        console.log(err)
                    })

                this.$set(this.highlightData, 'finance', finance)
            },
            parseFilter() {
                let filterString = '?'

                let keys = Object.keys(this.filter)

                for (var i = 0; i < keys.length; i++) {
                    filterString += `${keys[i]}=${this.filter[keys[i]]}&`
                }

                return filterString
            },
            async loadData() {
                //Reset Highlight Data
                this.highlightData = {};

                let url = '/api/v1/homepage'

                let filterTime = await this.parseFilter()

                this.$http.get(url + filterTime)
                .then((resp) => {
                    let data = resp.data.data;

                    for (var i in data) {
                        this.$set(this.highlightData, i, data[i])
                    }

                    let workOrderData = JSON.parse(JSON.stringify(data.work_order));
                })
                .then(() => {
                    console.log(JSON.stringify(Object.keys(this.highlightData)));
                    this.fetchFinanceData(filterTime);
                    console.log(JSON.stringify(Object.keys(this.highlightData)));
                })
                .catch((err) => {
                    console.log(err)
                })
            },
            generateYearOptions() {
                var years = [];
                for (var i = 2018; i <= new Date().getFullYear(); i++) years.push(i);
                this.options.year = years.reverse();
            },
            generateDummy() {
                var steps = ['pending', 'Warna', 'Bongkar', 'Las', 'Ketok', 'Dempul', 'Epoxy', 'Amplas Alus', 'Cat Base Coat', 'Cat', 'Pasang', 'Poles', 'Finishing']
                this.woOngoing = steps.map((x) => {
                    return {
                        step: x,
                        value: this.randomInt(1, 20)
                    }
                })
            }
        }
    }
</script>

<style>
    .homeFilter .multiselect__tags {
        background-color: #00CCCC !important;
    }
    
    .divider {
        width: 100% !important;
        border-top: 1px solid white;
        margin: 16px 0;
    }
    
    .homeFilter .multiselect__single,
    .homeFilter .multiselect__input,
    .homeFilter .multiselect__input::placeholder,
    .homeFilter .multiselect__placeholder {
        background-color: #00CCCC !important;
        color: white;
    }
    
    .homeFilter .multiselect__select::before {
        color: white !important;
    }
    
    .disabledButton .multiselect__select {
        background-color: #00CCCC
    }

    .hr-white {
        border-top: 1px solid white;
    }
    
    .buttonFilter {
        background-color: #fff;
        color: #00CCCC;
        border-color: #00CCCC;
    }
    
    .buttonFilter:hover,
    .buttonFilterSelected {
        background-color: #00CCCC;
        color: white;
    }
    
    .mini-stats {
        /* margin: 20px 0; */
    }
    
    .mini-stats .icon {
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    
    .mini-stats .icon i {
        color: lightblue;
        font-size: 3em;
    }
    
    .home-table-content {
        color: white;
        font-size: 16px;
    }
    
    .estimation-status {
        font-weight: 600;
        font-size: 16px;
        margin: 10px 0 0 0;
        color: white;
    }
    
    .estimation-value {
        font-weight: 600;
        font-size: 14px;
        margin-bottom: 0;
        color: white;
    }
    
    .custom-text-pink {
        color: pink;
    }
    
    .align-spacely {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
    }
    
    .align-spacely hr {}
</style>

<style scoped>
</style>